import React from "react";
import { Navigate, useParams } from "react-router-dom";
import hirebeen from '../image/hirebeenLogo.png';
import hide from "../image/icons/hide.png";
import view from "../image/icons/view.png";
import H from '../image/H.png';
import Group1 from '../image/Group1.svg';
import Group2 from '../image/Group2.svg';
import Group3 from '../image/Group3.svg';
import { useState } from "react";
import { connect } from "react-redux";
import { resetPasswordConfirm } from "../reducer/Actions";

const ResetPasswordConfirm = ({ resetPasswordConfirm }) => {
    const [ status, setStatus ] = useState (false);
    const { uid, token } = useParams();
    const [ formData, setFormData ] = useState ({
        new_password1: "",
        new_password2: ""
    });
    const { new_password1, new_password2 } = formData;
    const handlingInput = (e) => setFormData({...formData, [e.target.name]: e.target.value});
    const handlingSubmit = (e) => {
        e.preventDefault();
        resetPasswordConfirm( uid, token, new_password1, new_password2);
        setStatus(true);
    }
    if (status) {
        return <Navigate to={"../login/"}></Navigate>
    }
    return (
        <div class="grid gap-0 grid-cols-2 md:grid-cols-1">
        <div class="w-full h-full  bg-conic-gradient block max-md:hidden">
        <div className="flex gap-2.5 self-start max-md:pr-5 mt-6 ml-6">
          <img
            loading="lazy"
            src={H}
            alt="H"
            className="shrink-1 aspect-[0.75] w-[29px]"
          />
          <img
            loading="lazy"
            src={hirebeen}
            alt="Hirebeen"
            className="shrink-0 my-auto max-w-full aspect-[5.56] w-[146px]"
          />
        </div>
        <div className=" mx-9 mt-20 text-5xl font-bold text-white leading-[70px] max-md:mt-10 max-md:mr-2.5 max-md:max-w-full max-md:text-4xl max-md:leading-[68px]">
          Build your successful resume instantly using AI
        </div>
        <div className="z-10 self-center mt-3.5 max-w-full w-[574px]">
          <div className="flex gap-1 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-11/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col mt-16 grow max-md:mt-10">
                <img
                  loading="lazy"
                  src={Group2}
                  alt="Group"
                  className="w-full"
                />
                <img
                  loading="lazy"
                  src={Group3}
                  alt="Group"
                  className="w-full mt-5"
                />
              </div>
            </div>
            <div className="flex flex-col w-11/12 ml-5 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col max-md:mt-6">
                <img
                  loading="lazy"
                  src={Group1}
                  alt="Group"
                  className="w-full "
                />
                <img
                  loading="lazy"
                  src={Group3}
                  alt="Group"
                  className="w-full mt-5"
                />
              </div>
            </div>
          </div>
        </div>
        </div>
        <div className="flex flex-col items-center mt-40 rounded max-md:mt-20">
            <h2 className="text-4xl font-semibold leading-10 tracking-tighter text-gray-900 w-80 max-md:mt-4 max-md:max-w-full">Set Password</h2>
            <form className="mt-4 mb-3 w-80" onSubmit={e => handlingSubmit(e)}>
                <div className="mb-3">
                    <label htmlFor="new_password1" className="form-label">New Password</label>
                    <input name="new_password1" value={new_password1} onChange={e => handlingInput(e)} type="password" className="form-control outline-none w-full py-1 px-4 mt-[-10px] border rounded-md mb-4 text-lg" id="new_password1" placeholder="Enter new password"/>
                </div>
                <div className="mb-3">
                    <label htmlFor="new_password2" className="form-label">Confirm New Password</label>
                    <input name="new_password2" value={new_password2} onChange={e => handlingInput(e)} type="password" className="form-control outline-none w-full py-1 px-4 mt-[-10px] border rounded-md mb-4 text-lg" id="new_password2" placeholder="Confirm password"/>
                </div>
                <div className="gap-2 d-grid">
                    <button className="w-full px-4 py-1 font-semibold text-center text-white bg-orange-500 rounded-md outline-none hover:bg-orange-300 hover:text-white" type="submit">Set Password</button>
                </div>
            </form>
        </div>
        </div>
    )
}

export default connect(null, { resetPasswordConfirm })(ResetPasswordConfirm);